module.exports = __webpack_public_path__ + "img/202.12af337c.jpg";